import { api } from "./client";
import { useResource } from "./useResource";

// Per-user diff-file "viewed" state (A9). GET the set on mount; PUT to toggle.
// `changedPaths` are files viewed at an earlier snapshot whose diff has since
// moved — the "changed since viewed" signal (§Viewed state).
export type UseDiffViewed = {
  readonly changedPaths: ReadonlyArray<string> | undefined;
  readonly loading: boolean;
  readonly refetch: () => void;
  // Files with agent/human replies since the last submitted round — "responses
  // since last review" (§Re-flagging after a round). Takes precedence over
  // "changed" on the file row.
  readonly respondedPaths: ReadonlyArray<string> | undefined;
  readonly viewedPaths: ReadonlyArray<string> | undefined;
};

export const useDiffViewed = (taskId: string | null): UseDiffViewed => {
  const { data, loading, refetch } = useResource<{
    changed?: ReadonlyArray<string>;
    responded?: ReadonlyArray<string>;
    viewed: ReadonlyArray<string>;
  }>(taskId ? `/tasks/${taskId}/diff/viewed` : null);
  return {
    changedPaths: data?.changed,
    loading,
    refetch,
    respondedPaths: data?.responded,
    viewedPaths: data?.viewed,
  };
};

export const setFileViewed = (
  taskId: string,
  path: string,
  viewed: boolean,
): Promise<unknown> =>
  api.put(`/tasks/${taskId}/diff/viewed`, { path, viewed });
